import CommonForm from "../CommonComponent/CommonForm";

const GetLoanDetails = () => {
  const fields = [
    {
      name: "Loan ID",
      inputPlaceholder: "Enter Loan ID",
    },
    {
      name: "Mobile Number",
      inputPlaceholder: "Enter Mobile NUmber",
    },
  ];
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CommonForm
        fields={fields}
        heading={"Enter Details"}
        buttonName="Verify"
      />
    </div>
  );
};

export default GetLoanDetails;
